import type { CSSProperties } from 'react'

/** Off-screen, not `display:none` (Security §3.2): bots that skip hidden fields still see it. */
const OFF_SCREEN: CSSProperties = {
  position: 'absolute',
  left: '-10000px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
}

/**
 * The honeypot (Security §3.2 "Honeypot field rules", Frontend §4.6): a text input named `hpx`, off-screen, out of the
 * tab order, hidden from assistive technology and from autofill. Real patients never see or fill it; its value is
 * sent as `bot.hp` (a filled one blocks the visit, answered silently on lookup, D-48).
 */
export function Honeypot({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return (
    <div style={OFF_SCREEN} aria-hidden="true" data-testid="hpx-field">
      <input
        type="text"
        name="hpx"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
      />
    </div>
  )
}
